import 'regenerator-runtime/runtime'
import useBSSLogger from '../hooks/useBSSLogger';
import getapiclient, { getwpclient } from '../lib/ajaxhelper';

const {logger} = useBSSLogger();

const wpCurl = async (url) => {

    const {data} = await getwpclient().post("spedizioniweb2_curl", {url}, {responseType: 'document'})    

    logger.debug("ottenuto contenuto", data)
    return data; 
}


export {wpCurl}
